import React from "react";
import { InputContainer } from "../../Form";
import Select from "react-select";

export const SelectInput = ({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  isRequired = false,
  isSearchable = true,
  menuPlacement = "top",
  flex = "1 0 auto",
  width = "auto",
  styles
}) => {
  return (
    <InputContainer
      id={id}
      label={label}
      textLen={value?.length}
      isRequired={isRequired}
      flex={flex}
      width={width}
      render={(ID) => (
        <Select
          id={ID}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          options={options}
          isSearchable={isSearchable}
          menuPlacement={menuPlacement}
          styles={styles}
        />
      )}
    />
  );
};
